const CodeChefIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none">
    <path d="M32 0C14.3 0 0 14.3 0 32s14.3 32 32 32 32-14.3 32-32S49.7 0 32 0zm0 58C17.5 58 6 46.5 6 32S17.5 6 32 6s26 11.5 26 26-11.5 26-26 26zm-4.2-40h8.4c1 0 1.8.8 1.8 1.8v18.4c0 1-.8 1.8-1.8 1.8h-8.4c-1 0-1.8-.8-1.8-1.8V19.8c0-1 .8-1.8 1.8-1.8zm2 2v16.4h4.4V20h-4.4z" fill="#5A3C1B" />
  </svg>
);

export default CodeChefIcon;
